import * as Sentry from '@sentry/vue'

class TileStore {
  #db = null

  constructor () {
    const request = self.indexedDB.open('tracker-tiles', 1)

    request.onsuccess = event => { this.#db = event.target.result }
    request.onerror = () => Sentry.captureException(request.error)
    request.onupgradeneeded = event => {
      this.#db = event.target.result

      const store = this.#db.createObjectStore('tiles', { keyPath: ['z', 'x', 'y'] })
      store.createIndex('x', 'x')
      store.createIndex('y', 'y')
      store.createIndex('z', 'z')
    }
  }

  // async pull (tiles, api, progressCallback) {
  //   await this.clear()
  //   progressCallback(0, tiles.length)

  //   for (let i = 0; i < tiles.length; i++) {
  //     const keys = tiles[i].split('-')
  //     if (keys.some(d => d === '')) continue
  //     const [z, x, y] = keys.map(Number)

  //     const tile = await api.getTile({ x, y, z })
  //     await this.#set({ x, y, z }, { tile })
  //     if (progressCallback) progressCallback(i + 1, tiles.length)
  //   }
  // }

  async pull (tiles, api, progressCallback) {
    await this.clear()
    if (progressCallback) progressCallback(0, tiles.length)

    const chunks = []
    const chunkSize = 100
    for (let i = 0; i < tiles.length; i += chunkSize) chunks.push(tiles.slice(i, i + chunkSize))

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i]
      const { data, sizes } = await api.getTiles(chunk)

      let offset = 0
      for (let j = 0; j < chunk.length; j++) {
        const [z, x, y] = chunk[j].split('-').map(Number)
        const tile = data.slice(offset, offset += sizes[j])
        await this.#set({ x, y, z }, { tile })
      }
      if (progressCallback) progressCallback((i + 1) * chunkSize, tiles.length)
    }
  }

  async get ({ x, y, z }) {
    return new Promise((resolve, reject) => {
      const store = this.#db.transaction(['tiles'], 'readwrite').objectStore('tiles')
      const transaction = store.get([z, x, y])

      transaction.onsuccess = () => resolve(transaction.result)
      transaction.onerror = reject
    })
  }

  async #set ({ x, y, z }, data) {
    return new Promise((resolve, reject) => {
      const store = this.#db.transaction(['tiles'], 'readwrite').objectStore('tiles')
      const transaction = store.add({ x, y, z, ...data })

      transaction.onsuccess = () => resolve()
      transaction.onerror = reject
    })
  }

  async clear () {
    return new Promise((resolve, reject) => {
      const transaction = this.#db.transaction(['tiles'], 'readwrite')
      const store = transaction.objectStore('tiles')
      const req = store.clear()

      transaction.onsuccess = () => resolve()
      req.onsuccess = () => resolve()
      transaction.onerror = reject
    })
  }
}

const tileStore = new TileStore()
export default tileStore
